import { useCallback, useEffect, useState } from 'react'

export function useFirstUserScroll() {
	const [firstUserScroll, setFirstUserScroll] = useState(false)
	const firstUserScrollHandler = useCallback(() => {
		setFirstUserScroll(true)
	}, [])
	useEffect(() => {
		window.addEventListener('scroll', firstUserScrollHandler, { once: true })
		return () => window.removeEventListener('scroll', firstUserScrollHandler)
	}, [firstUserScrollHandler])
	return firstUserScroll
}
